import { reactive } from 'vue';
import LoadingModal from './LoadingModal';

const loading = reactive({
    state: false,
    show() {
        this.state = true;
    },
    close() {
        this.state = false;
    }
});

const loadingPlugin = {
    install(app, options) {
        app.config.globalProperties.$loading = loading;
        app.component('LoadingModal', LoadingModal);
    }
}

export default loadingPlugin;